import { defineSemanticTokens } from "@chakra-ui/react";

import {
  buttonSemanticTokens,
  tabsSemanticTokens,
  inputSemanticTokens,
  cardSemanticTokens,
  headingSemanticTokens,
  textSemanticTokens,
  linkSemanticTokens,
  toastSemanticTokens,
} from "./components";

export const semanticTokens = defineSemanticTokens({
  colors: {
    bg: {
      button: buttonSemanticTokens.bg,
      tabs: tabsSemanticTokens.bg,
      input: inputSemanticTokens.bg,
      card: cardSemanticTokens.bg,
      toast: toastSemanticTokens.bg,
    },
    text: {
      ...textSemanticTokens.text,
      button: buttonSemanticTokens.text,
      tabs: tabsSemanticTokens.text,
      input: inputSemanticTokens.text,
      heading: headingSemanticTokens.text,
      card: cardSemanticTokens.text,
      link: linkSemanticTokens.text,
      toast: toastSemanticTokens.text,
    },
    border: {
      tabs: tabsSemanticTokens.border,
      input: inputSemanticTokens.border,
      card: cardSemanticTokens.border,
      toast: toastSemanticTokens.border,
    },
  },
  fontSizes: {
    button: buttonSemanticTokens.fontSizes,
    tabs: tabsSemanticTokens.fontSizes,
    input: inputSemanticTokens.fontSizes,
    heading: headingSemanticTokens.fontSizes,
    text: textSemanticTokens.fontSizes,
    link: linkSemanticTokens.fontSizes,
  },
  fontWeights: {
    tabs: tabsSemanticTokens.fontWeights,
    input: inputSemanticTokens.fontWeights,
    button: buttonSemanticTokens.fontWeights,
    heading: headingSemanticTokens.fontWeights,
    text: textSemanticTokens.fontWeights,
    link: linkSemanticTokens.fontWeights,
  },
  radii: {
    button: buttonSemanticTokens.radii,
    tabs: tabsSemanticTokens.radii,
    input: inputSemanticTokens.radii,
    card: cardSemanticTokens.radii,
    toast: toastSemanticTokens.radii,
  },
});
